import styles from "./Skeleton.module.css";

type SkeletonProps = {
  readonly width?: string;
  readonly height?: string;
  readonly radius?: string;
  readonly className?: string;
};

// Shimmer placeholder primitive. Sections compose it into layouts that
// mirror their real content so nothing reflows when data lands.
export const Skeleton = ({ width, height, radius, className }: SkeletonProps): JSX.Element => (
  <span
    className={className === undefined ? styles.block : `${styles.block} ${className}`}
    style={{ width, height, borderRadius: radius }}
    aria-hidden
  />
);
